<script lang="ts" setup>
import { computed } from 'vue';
import FieldChoice from './FieldChoice.vue';
import FieldCondition from './FieldCondition.vue';
import { Option } from '@/helpers/Interfaces';
import { DetailsBuilderContract } from '@/components/builder/details';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';
import { FieldType } from '../blueprints/field';

defineOptions({
    name: 'field-col-visible',
    components: {
        'field-choice': FieldChoice,
        'field-condition': FieldCondition
    }
});

const props = defineProps({
  "blueprint": null,
  "details": null,
  "label": { default: null }
});
const blueprint = computed(() => props.blueprint);

const visibleColOptions: Option<AlwaysChoice | WhenChoice>[] = [
    { value: AlwaysChoice.Always, text: '[[[Zawsze]]]' },
    { value: WhenChoice.When, text: '[[[Warunkowo]]]' }
];

</script>

<template>
    <div>
        <field-choice v-model="blueprint.visibleCol" :options="visibleColOptions" :label="label || $t('[[[Widoczność kolumn]]]')" />
        <field-condition v-model="blueprint.visibleColWhen" type="columns" :label="label" :show-label="false" :details="details" :when="blueprint.visibleCol" />
    </div>
</template>
